import { render, staticRenderFns } from "./CustomerRecommend.vue?vue&type=template&id=f10e2948&scoped=true&"
import script from "./CustomerRecommend.vue?vue&type=script&lang=js&"
export * from "./CustomerRecommend.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRecommend.vue?vue&type=style&index=0&id=f10e2948&lang=less&scoped=true&"
import style1 from "./CustomerRecommend.vue?vue&type=style&index=1&lang=less&"
import style2 from "./CustomerRecommend.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10e2948",
  null
  
)

export default component.exports